/**
 * MM-MODAL-MOTO.JS — Modale de sélection de moto (préfixe MM = agence Moon Moon)
 *
 * Rôle : sur une fiche produit "support moto", le client choisit la marque et le
 * modèle de sa moto/scooter pour vérifier la compatibilité du produit courant et
 * obtenir jusqu'à 4 recommandations de supports compatibles (carrousel Splide).
 *
 * Fonctionne avec sections/MM-Modal-Moto.liquid qui fournit :
 *  - l'île .moto-metafield-json : VIDE avec data-src = URL de l'asset
 *    mm-json-motos.json (base motos, téléchargée en tâche de fond par
 *    chargerBaseMotos() — 29/07/2026, fin de l'inline 1,7 Mo/metaobjet)
 *  - les éléments DOM #mm-moto-* (selects cachés, zones de résultat, textes traduits)
 *  - les cartes produits .mm-moto-product (données via attributs data-*)
 *
 * Expose en global : mmOpenMotoModal() / mmCloseMotoModal() (appelées aussi par
 * Lucky Orange via theme.liquid) ainsi que forgetUserChoice().
 *
 * Persistance : localStorage ("Moto_model" + clés "compatibility_*") pour
 * mémoriser le choix du client entre les pages produit.
 */

// Données construites au chargement par parseJson() à partir du JSON metafield
const brands = [];
const allModels = [];
const currentProductTypology = document.getElementById('mm-moto-current-product').value;
const brandSelect = document.getElementById('mm-moto-marque-select');
const modelSelect = document.getElementById('mm-moto-modele-select');
const modelSelectText = modelSelect.dataset.selectText;
const validateModel = document.querySelector('.mm-moto-submit');
const motoCompatibilityTrue = document.getElementById('mm-moto-compatibility-true');
const motoCompatibilityFalse = document.getElementById('mm-moto-compatibility-false');
const motoResult = document.getElementById('mm-moto-result');
const motoProductsData = document.querySelectorAll('.mm-moto-product');
const motoError = document.getElementById('mm-moto-error');
const sorryText = document.getElementById('mm-moto-sorry-text').innerHTML;
const endStep2 = document.querySelector('.mm-moto-modal-end-step-2');
const endStep3 = document.querySelector('.mm-moto-modal-end-step-3');

// PREDICTIVE SEARCH ELEMENTS
const motoSearchInput = document.getElementById('mm-moto-search-input');
const motoSearchResults = document.getElementById('mm-moto-search-results');
const motoSearchNotFound = document.getElementById('mm-moto-search-not-found');
let motoSearchDebounceTimer = null;
let motoSearchSelectedIndex = -1;

// SPLIDE RECOS
var id = '.splide-moto-result';
var splideElem = document.querySelector(id);
var splideRecos;

// Initialise le carrousel Splide des recommandations dès que le DOM est prêt.
// La librairie Splide est chargée globalement par le thème.
document.addEventListener("DOMContentLoaded", (event) => {
  splideRecos = new Splide( splideElem, {
    type   : 'splide',
    arrows: true,
    pagination: false,
    rewind: true,
    gap: 20,
    perPage: 1
  })
  splideRecos.mount();
});


// Callback de filtre pour dédupliquer un tableau.
// NB : ne semble plus utilisée (la déduplication des marques passe par new Set dans parseJson).
function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

// Ferme la modale (retire la classe .mm-visible) et nettoie la recherche.
// Exposée en global — appelée depuis le Liquid (onclick) et hookée par Lucky Orange.
// 01/09/2026 (audit S36, chantier 7) : appel updateTextButton(false) retiré —
// la fonction a été supprimée avec le calculateur de tailles (allègement M2 du
// 12/06, cf. MM-Modal-Tailles.liquid) et l'appel survivant levait une
// ReferenceError à chaque fermeture de la modale.
function mmCloseMotoModal() {
  document.querySelector('.mm-moto-modal-wrapper').classList.remove('mm-visible');
  mmCloseSearchDropdown();
}

// Ouvre la modale. Si aucun modèle n'est mémorisé en localStorage, on remet
// d'abord la modale à zéro (sinon on conserve l'état/le résultat précédent).
// Exposée en global — appelée depuis le Liquid (onclick) et hookée par Lucky Orange.
function mmOpenMotoModal() {
  // Branche volontairement vide : si "Moto_model" existe on garde l'état courant
  if(localStorage.getItem("Moto_model")){
  } else {
    mmRefreshModal();
  }
  document.querySelector('.mm-moto-modal-wrapper').classList.add('mm-visible');
}

// Remet la modale à l'état initial : selects réinitialisés, champ de recherche
// vidé, messages de compatibilité masqués, résultats effacés, étapes "fin" repliées.
function mmRefreshModal() {
  brandSelect.selectedIndex = 0;
  modelSelect.selectedIndex = 0;
  motoSearchInput.value = '';
  mmSetOverlayText('');
  mmCloseSearchDropdown();
  if(motoCompatibilityTrue){motoCompatibilityTrue.style.display = 'none'};
  if(motoCompatibilityFalse){motoCompatibilityFalse.style.display = 'none'};
  motoResult.innerHTML = "";
  document.querySelector('.mm-moto-modal-end').style.display = 'none';
  endStep2.style.display = 'block';
  endStep3.style.display = 'none';
}

// 29/07/2026 : la base motos n'est plus inlinée dans le HTML (1,7 Mo par PDP
// moto, plafond metaobjet atteint) — elle vit dans l'asset mm-json-motos.json
// dont l'URL est portée par data-src de l'île .moto-metafield-json.
// chargerBaseMotos() la télécharge dès l'init (prête bien avant le 1er clic).
// mmBaseMotosPrete (Promise) permet au rejeu getMotoModel() d'attendre la base.
// Le repli « île inline » de la transition a été RETIRÉ (demande Christopher,
// 29/07) : seul l'asset fait foi. Sans risque pour les caches : un vieux HTML
// référence l'ancien JS versionné qui lit son île encore remplie — chaque
// combinaison HTML/JS servie reste cohérente.
var mmBaseMotosPrete = null;

function chargerBaseMotos() {
  var ile = document.querySelector('.moto-metafield-json');
  var url = ile && ile.dataset.src;
  if (!url) {
    console.error('[modal moto] data-src absent sur .moto-metafield-json');
    return;
  }
  mmBaseMotosPrete = fetch(url)
    .then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    })
    .then(function (texte) { parseJsonMotos(texte); })
    .catch(function (e) { console.error('[modal moto] échec du chargement de la base motos', e); });
}

// Exécuté immédiatement au chargement du script : charge le JSON de compatibilité,
// peuple les selects cachés et branche les listeners (change marque, clic Valider).
chargerBaseMotos();

// =====================
// PREDICTIVE SEARCH
// =====================
// Recherche prédictive locale (aucun appel réseau) sur la liste marque + modèle,
// avec tolérance aux fautes de frappe (distance de Levenshtein), surlignage des
// termes trouvés et autocomplétion "fantôme" (overlay + touche Tab).

// Normalise une chaîne pour la comparaison : supprime les accents (décomposition
// NFD), passe en minuscules et compacte les espaces.
function mmNormalize(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s+/g, ' ').trim();
}

// Entoure de <strong> les portions de `text` qui correspondent aux termes de la
// requête (comparaison sur la version normalisée, rendu sur le texte d'origine).
function mmHighlightMatch(text, query) {
  var normalizedText = mmNormalize(text);
  var terms = mmNormalize(query).split(' ').filter(function(t) { return t.length > 0; });
  // Build array of character highlight flags
  var highlights = new Array(text.length).fill(false);
  terms.forEach(function(term) {
    var startPos = 0;
    var normalizedLower = normalizedText;
    while (true) {
      var idx = normalizedLower.indexOf(term, startPos);
      if (idx === -1) break;
      for (var i = idx; i < idx + term.length && i < text.length; i++) {
        highlights[i] = true;
      }
      startPos = idx + term.length;
    }
  });
  // Build result string
  var result = '';
  var inBold = false;
  for (var i = 0; i < text.length; i++) {
    if (highlights[i] && !inBold) {
      result += '<strong>';
      inBold = true;
    } else if (!highlights[i] && inBold) {
      result += '</strong>';
      inBold = false;
    }
    result += text[i];
  }
  if (inBold) result += '</strong>';
  return result;
}

// Levenshtein distance (typo tolerance)
// Distance d'édition classique entre deux chaînes (programmation dynamique),
// utilisée pour tolérer les fautes de frappe dans la recherche.
function mmLevenshtein(a, b) {
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;
  var matrix = [];
  for (var i = 0; i <= b.length; i++) matrix[i] = [i];
  for (var j = 0; j <= a.length; j++) matrix[0][j] = j;
  for (var i = 1; i <= b.length; i++) {
    for (var j = 1; j <= a.length; j++) {
      if (b[i - 1] === a[j - 1]) {
        matrix[i][j] = matrix[i - 1][j - 1];
      } else {
        matrix[i][j] = Math.min(
          matrix[i - 1][j - 1] + 1,
          matrix[i][j - 1] + 1,
          matrix[i - 1][j] + 1
        );
      }
    }
  }
  return matrix[b.length][a.length];
}

// Teste si un terme de recherche correspond à un libellé : d'abord en sous-chaîne
// exacte, sinon en approché mot par mot (1 faute tolérée pour 4-5 lettres, 2 au-delà).
function mmFuzzyTermMatch(term, label) {
  // Exact substring match first
  if (label.indexOf(term) !== -1) return true;
  // Too short for fuzzy
  if (term.length < 4) return false;
  // Max allowed typos: 1 for 4-5 chars, 2 for 6+
  var maxDist = term.length <= 5 ? 1 : 2;
  var words = label.split(' ');
  return words.some(function(word) {
    return mmLevenshtein(term, word) <= maxDist;
  });
}

// Recherche dans allModels : chaque terme de la requête doit matcher (fuzzy) le
// libellé "Marque Modèle". Retourne au maximum 20 résultats.
function mmSearchModels(query) {
  var normalizedQuery = mmNormalize(query);
  if (!normalizedQuery.length) return [];
  var terms = normalizedQuery.split(' ').filter(function(t) { return t.length > 0; });
  return allModels.filter(function(item) {
    var normalizedLabel = mmNormalize(item.fullLabel);
    return terms.every(function(term) {
      return mmFuzzyTermMatch(term, normalizedLabel);
    });
  }).slice(0, 20);
}

// Affiche la liste déroulante des résultats : items cliquables avec surlignage,
// lien sticky "Vous ne trouvez pas votre moto ?" en bas, pré-sélection du premier
// résultat, et mise à jour de l'overlay d'autocomplétion.
function mmRenderSearchResults(results, query) {
  motoSearchResults.innerHTML = '';
  motoSearchSelectedIndex = -1;

  if (results.length === 0) {
    motoSearchResults.style.display = 'none';
    motoSearchNotFound.style.display = 'flex';
    mmSetOverlayText('');
    return;
  }

  motoSearchNotFound.style.display = 'none';
  results.forEach(function(item, index) {
    var li = document.createElement('li');
    li.className = 'mm-moto-search-result-item';
    li.setAttribute('role', 'option');
    li.setAttribute('data-index', index);
    li.setAttribute('data-brand', item.brand);
    li.setAttribute('data-model', item.model);

    var brandHighlighted = mmHighlightMatch(item.brand, query);
    var modelHighlighted = mmHighlightMatch(item.model, query);

    li.innerHTML = '<span class="mm-moto-search-result-brand">' + brandHighlighted + '</span> <span class="mm-moto-search-result-model">' + modelHighlighted + '</span>';

    li.addEventListener('click', function() {
      mmSelectSearchResult(item);
    });

    li.addEventListener('mouseenter', function() {
      mmSetActiveResult(index);
    });

    motoSearchResults.appendChild(li);
  });

  // Show "not found" link sticky at bottom
  var notFoundLi = document.createElement('li');
  notFoundLi.className = 'mm-moto-search-result-not-found-sticky';
  notFoundLi.innerHTML = `<span>Vous ne trouvez pas votre moto/scooter ?</span> <span class="mm-moto-search-not-found-link" >Cliquez ici</span>`;
  notFoundLi.querySelector('.mm-moto-search-not-found-link').addEventListener('click', function(e) {
    e.stopPropagation();
    mmCloseSearchDropdown();
    document.querySelector('.mm-moto-modal-end').style.display = 'block';
  });
  motoSearchResults.appendChild(notFoundLi);

  motoSearchResults.style.display = 'block';
  motoSearchInput.setAttribute('aria-expanded', 'true');

  // Auto-select first result
  mmSetActiveResult(0);

  // On first mouse move in the list, clear auto-selection and let hover take over
  motoSearchResults.addEventListener('mousemove', function onMotoMouseMove() {
    var items = motoSearchResults.querySelectorAll('.mm-moto-search-result-item');
    items.forEach(function(item) {
      item.classList.remove('mm-moto-search-result-active');
      item.setAttribute('aria-selected', 'false');
    });
    motoSearchSelectedIndex = -1;
    motoSearchResults.removeEventListener('mousemove', onMotoMouseMove);
  });

  // Autocomplete overlay: show best matching suggestion
  mmUpdateOverlay(results, query);
}

// Écrit le texte "fantôme" d'autocomplétion dans l'overlay positionné derrière
// le champ de recherche (#mm-moto-search-overlay).
function mmSetOverlayText(text) {
  var el = document.getElementById('mm-moto-search-overlay');
  if (el) el.textContent = text;
}

// Cherche le premier résultat dont le libellé commence exactement par la requête
// et affiche la fin du libellé en suggestion (complétable avec Tab). Sinon, vide.
function mmUpdateOverlay(results, query) {
  if (!results || !results.length || !query || !query.length) {
    mmSetOverlayText('');
    return;
  }
  var normalizedQuery = mmNormalize(query);
  for (var i = 0; i < results.length; i++) {
    var normalizedLabel = mmNormalize(results[i].fullLabel);
    if (normalizedLabel.indexOf(normalizedQuery) === 0) {
      mmSetOverlayText(query + normalizedLabel.substring(normalizedQuery.length));
      return;
    }
  }
  mmSetOverlayText('');
}

// Met en surbrillance le résultat d'index donné (classe + aria-selected) et le
// fait défiler dans la vue. Utilisée par la navigation clavier et le survol souris.
function mmSetActiveResult(index) {
  var items = motoSearchResults.querySelectorAll('.mm-moto-search-result-item');
  items.forEach(function(item) {
    item.classList.remove('mm-moto-search-result-active');
    item.setAttribute('aria-selected', 'false');
  });
  if (index >= 0 && index < items.length) {
    items[index].classList.add('mm-moto-search-result-active');
    items[index].setAttribute('aria-selected', 'true');
    items[index].scrollIntoView({ block: 'nearest' });
    motoSearchSelectedIndex = index;
  }
}

// Validation d'un résultat de recherche : remplit le champ avec le libellé complet,
// ferme le dropdown puis pilote les selects cachés pour déclencher la logique existante.
function mmSelectSearchResult(item) {
  motoSearchInput.value = item.fullLabel;
  mmSetOverlayText('');
  mmCloseSearchDropdown();

  // Program hidden selects with matching values and trigger validation
  mmProgramHiddenSelects(item.brand, item.model);
}

// Pont entre la recherche prédictive et l'ancienne logique à 2 selects :
// slugifie marque/modèle, sélectionne la marque (déclenche le change qui peuple
// le select des modèles), puis sélectionne le modèle et clique sur "Valider".
function mmProgramHiddenSelects(brand, model) {
  var brandSlug = brand.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
  var modelSlug = model.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

  for (var i = 0; i < brandSelect.options.length; i++) {
    if (brandSelect.options[i].value === brandSlug) {
      brandSelect.selectedIndex = i;
      var event = new Event('change');
      brandSelect.dispatchEvent(event);
      break;
    }
  }

  // Small timeout to let the model select populate after brand change
  setTimeout(function() {
    for (var j = 0; j < modelSelect.options.length; j++) {
      if (modelSelect.options[j].value === modelSlug) {
        modelSelect.selectedIndex = j;
        validateModel.click();
        break;
      }
    }
  }, 50);
}

// Ferme et vide la liste de résultats + le bloc "non trouvé", réinitialise
// l'index sélectionné et l'état ARIA du champ.
function mmCloseSearchDropdown() {
  motoSearchResults.style.display = 'none';
  motoSearchResults.innerHTML = '';
  motoSearchNotFound.style.display = 'none';
  motoSearchSelectedIndex = -1;
  motoSearchInput.setAttribute('aria-expanded', 'false');
}

// SEARCH INPUT EVENTS
// Saisie : mise à jour immédiate de l'overlay (réactivité perçue) puis rendu
// complet des résultats débounce à 150 ms (recherche purement locale).
motoSearchInput.addEventListener('input', function() {
  clearTimeout(motoSearchDebounceTimer);
  var query = motoSearchInput.value.trim();

  if (!query.length) {
    mmCloseSearchDropdown();
    mmSetOverlayText('');
    return;
  }

  // Immediate overlay update for responsiveness
  var quickResults = mmSearchModels(query);
  if (quickResults.length > 0) {
    mmUpdateOverlay(quickResults, query);
  } else {
    mmSetOverlayText('');
  }

  // Debounced full search (150ms – local array, no network call)
  motoSearchDebounceTimer = setTimeout(function() {
    var results = mmSearchModels(query);
    mmRenderSearchResults(results, query);
  }, 150);
});

// Navigation clavier dans le dropdown : flèches haut/bas (avec bouclage),
// Entrée = valider le résultat actif, Tab = accepter l'autocomplétion overlay,
// Échap = fermer.
motoSearchInput.addEventListener('keydown', function(e) {
  var items = motoSearchResults.querySelectorAll('.mm-moto-search-result-item');
  var isOpen = motoSearchResults.style.display === 'block';

  if (e.key === 'ArrowDown') {
    e.preventDefault();
    if (!isOpen) return;
    var newIndex = motoSearchSelectedIndex + 1;
    if (newIndex >= items.length) newIndex = 0;
    mmSetActiveResult(newIndex);
  } else if (e.key === 'ArrowUp') {
    e.preventDefault();
    if (!isOpen) return;
    var newIndex = motoSearchSelectedIndex - 1;
    if (newIndex < 0) newIndex = items.length - 1;
    mmSetActiveResult(newIndex);
  } else if (e.key === 'Enter') {
    e.preventDefault();
    if (isOpen && items.length > 0) {
      var selectedIdx = motoSearchSelectedIndex >= 0 ? motoSearchSelectedIndex : 0;
      var selectedItem = items[selectedIdx];
      var brand = selectedItem.getAttribute('data-brand');
      var model = selectedItem.getAttribute('data-model');
      var matchedModel = allModels.find(function(m) {
        return m.brand === brand && m.model === model;
      });
      if (matchedModel) {
        mmSelectSearchResult(matchedModel);
      }
    }
  } else if (e.key === 'Tab') {
    // Tab autocompletes with first suggestion
    var overlayEl = document.getElementById('mm-moto-search-overlay');
    var overlayText = overlayEl ? overlayEl.textContent : '';
    if (overlayText && overlayText !== motoSearchInput.value) {
      e.preventDefault();
      motoSearchInput.value = overlayText;
      mmSetOverlayText('');
      // Trigger a new search with the full value
      clearTimeout(motoSearchDebounceTimer);
      var results = mmSearchModels(motoSearchInput.value.trim());
      mmRenderSearchResults(results, motoSearchInput.value.trim());
    }
  } else if (e.key === 'Escape') {
    mmCloseSearchDropdown();
    mmSetOverlayText('');
  }
});

// Close dropdown when clicking outside
document.addEventListener('click', function(e) {
  if (!e.target.closest('.mm-moto-search-container')) {
    mmCloseSearchDropdown();
    mmSetOverlayText('');
  }
});


// =====================
// EXISTING LOGIC (CTA, VALIDATION, RECOS)
// =====================

// Après validation d'un modèle : mémorise "Marque - Modèle" en localStorage,
// remplace le(s) bouton(s) d'ouverture de la modale dans #product-form par un
// badge vert/rouge (compatible / non compatible) avec croix pour oublier le choix,
// et met à jour le bandeau de taille de la carte sélectionnée du sélecteur support.
function mmUpdateCTA(is_compatible, brand, model) {
  // Set item
  localStorage.setItem("Moto_model", `${brand.trim()} - ${model.trim()}`);

  var button = document.querySelector('#product-form .mm-moto-modal-button');
  var buttons = document.querySelectorAll("#product-form .mm-moto-modal-button");

  console.log(buttons)

  if (buttons) {
    buttons.forEach(button => {
      const isDesktop = button.classList.contains('mm-desktop');

      const baseClass = 'mm-moto-modal-button';
      const desktopClass = isDesktop ? ' mm-desktop' : '';
      const compatibilityClass = is_compatible
        ? ' mm-moto-cta-compatible'
        : ' mm-moto-cta-not-compatible';

      button.outerHTML = `
        <span class="${baseClass}${compatibilityClass}${desktopClass}" id="mmMotoModalButton">
          <p onclick="mmOpenMotoModal()">${brand} - ${model}</p>
          <svg onclick="forgetUserChoice()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>
      `;
    });
  }

  const selectedCard = document.querySelector('.mm-selector-support-product .mm-selector-card-selected');
  const supportContainer = document.querySelector('.mm-selector-support-container');

  if (selectedCard && supportContainer) {
    const sizeBanner = selectedCard.querySelector('.mm-selector-card-size');

    if (sizeBanner) {
      const compatibleText = supportContainer.getAttribute('data-comptabile');
      const notCompatibleText = supportContainer.getAttribute('data-no-comptabile');

      if (is_compatible) {
        sizeBanner.textContent = compatibleText;
      } else {
        sizeBanner.textContent = notCompatibleText;
      }
    } else {
      console.log('Élément .mm-selector-card-size non trouvé dans la carte sélectionnée.');
    }
  } else {
    console.log('Carte sélectionnée ou conteneur support non trouvé.');
  }



}

// Parse JSON
// Cœur de la modale. Lit le JSON de compatibilité (metafield rendu dans
// .moto-metafield-json par MM-Modal-Moto.liquid) puis :
//  1. construit l'index plat allModels pour la recherche prédictive ;
//  2. peuple le select caché des marques (valeurs slugifiées) ;
//  3. au changement de marque : régénère les options du select modèles, chaque
//     option portant en data-* la compatibilité OUI/NON et le texte argumentaire
//     de CHAQUE typologie de produit (Moto, Moto Pro, Mirror, etc.) ;
//  4. au clic "Valider" : vérifie la compatibilité avec le produit courant
//     (typologie lue dans #mm-moto-current-product), stocke en localStorage,
//     affiche le message OUI/NON et construit le carrousel de recos (max 4).
// 29/07/2026 : reçoit le texte JSON en paramètre (asset téléchargé par
// chargerBaseMotos()) au lieu de lire lui-même le DOM.
// 03/08/2026 : renommée parseJsonMotos (nom UNIQUE) — le guide des tailles
// définissait lui aussi un parseJson global ; avec les appels asynchrones,
// la dernière définition chargée répondait aux deux fetchs.
function parseJsonMotos(texteJson) {
  var jsonData = JSON.parse(texteJson);

  // Build flat index for predictive search
  jsonData.map(function(modelData) {
    brands.push({ brand: modelData.Marque });
    allModels.push({
      brand: modelData.Marque,
      model: modelData.Modèle,
      fullLabel: modelData.Marque + ' ' + modelData.Modèle
    });
  });

  // Populate hidden brand select (keep for existing logic)
  var brands_unique = [...new Set(brands.map(item => item.brand))];
  brands_unique.forEach(function(brand){
    var htmlElement = `<option value="${brand.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}">${brand}</option>`;
    brandSelect.insertAdjacentHTML('beforeend', htmlElement);
  })

  brandSelect.addEventListener('change', function(e){
    var models = [];
    jsonData.map((modelData) => {
      if(modelData.Marque == brandSelect.options[brandSelect.selectedIndex].text){
        models.push({
          model: modelData.Modèle,
          reco: modelData.Recommandation,
          moto: modelData['Moto'],
          argumoto: modelData['Texte argu Moto'],
          motopro: modelData['Moto Pro'],
          argumotopro: modelData['Texte argu Moto Pro'],
          motoproboost: modelData['Moto Pro Boost'],
          argumotoproboost: modelData['Texte argu Moto Pro Boost'],
          motostem: modelData['Moto Stem'],
          argumotostem: modelData['Texte argu Moto Stem'],
          motostemboost: modelData['Moto Stem Boost'],
          argumotostemboost: modelData['Texte argu Moto Stem Boost'],
          mirror: modelData['Mirror'],
          argumirror: modelData['Texte argu Mirror'],
          mirrorpro: modelData['Mirror Pro'],
          argumirrorpro: modelData['Texte argu Mirror Pro'],
          scooterscrew: modelData['Scooter Screw'],
          arguscooterscrew: modelData['Texte argu Scooter Screw'],
          proboosttu: modelData['Pro Boost TU'],
          arguproboosttu: modelData['Texte argu Pro Boost TU'],
          protu: modelData['Pro Tu'],
          arguprotu: modelData['Texte argu Pro Tu'],
          mototu: modelData['Moto Tu'],
          argumototu: modelData['Texte argu Moto Tu'],
          motostemboostmini: modelData['Moto Stem Boost Mini'],
          argumotostemboostmini: modelData['Texte argu Moto Stem Boost Mini']
        })
      }
    });
    modelSelect.innerHTML = `<option value="" id="mm-moto-model-empty">${modelSelectText}</option>`;
    models.forEach(function(model){
      var htmlElement = `
      <option value="${model.model.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}"
        data-moto="${model.moto}"
        data-argumoto="${model.argumoto}"
        data-motopro="${model.motopro}"
        data-argumotopro="${model.argumotopro}"
        data-motoproboost="${model.motoproboost}"
        data-argumotoproboost="${model.argumotoproboost}"
        data-motostem="${model.motostem}"
        data-argumotostem="${model.argumotostem}"
        data-motostemboost="${model.motostemboost}"
        data-argumotostemboost="${model.argumotostemboost}"
        data-mirror="${model.mirror}"
        data-argumirror="${model.argumirror}"
        data-mirrorpro="${model.mirrorpro}"
        data-argumirrorpro="${model.argumirrorpro}"
        data-scooterscrew="${model.scooterscrew}"
        data-arguscooterscrew="${model.arguscooterscrew}"
        data-proboosttu="${model.proboosttu}"
        data-arguproboosttu="${model.arguproboosttu}"
        data-protu="${model.protu}"
        data-arguprotu="${model.arguprotu}"
        data-mototu="${model.mototu}"
        data-argumototu="${model.argumototu}"
        data-motostemboostmini="${model.motostemboostmini}"
        data-argumotostemboostmini="${model.argumotostemboostmini}"
        data-reco="${model.reco}">${model.model}</option>`;
      modelSelect.insertAdjacentHTML('beforeend', htmlElement);
    })
  })

  // Clic sur "Valider" : si marque ou modèle non choisis -> message d'erreur,
  // sinon vérification de compatibilité + génération des recommandations.
  validateModel.addEventListener('click', function(e){

    motoError.style.display = 'none';
    if (brandSelect.selectedIndex == 0 || modelSelect.selectedIndex == 0) {
      motoError.style.display = 'block';
      if(motoCompatibilityTrue){motoCompatibilityTrue.style.display = 'none'}
      if(motoCompatibilityFalse){motoCompatibilityFalse.style.display = 'none'}
      motoResult.innerHTML = "";
    } else {

      // Set LocalStorage
      // Mémorise la compatibilité OUI/NON du modèle choisi pour chaque typologie,
      // relue par getMotoModel() sur les autres pages produit.
      // Correctif 12.06.2026 (bug B10) : avant ce correctif, "compatibility_proboosttu"
      // était écrit QUATRE fois (avec des textes d'argumentaire au lieu de OUI/NON) et
      // protu / mototu / motostemboostmini n'étaient jamais mémorisées -> ces typologies
      // apparaissaient à tort "non compatibles" au rechargement de page.
      localStorage.setItem("compatibility_moto", modelSelect.options[modelSelect.selectedIndex].dataset['moto']);
      localStorage.setItem("compatibility_motopro", modelSelect.options[modelSelect.selectedIndex].dataset['motopro']);
      localStorage.setItem("compatibility_motoproboost", modelSelect.options[modelSelect.selectedIndex].dataset['motoproboost']);
      localStorage.setItem("compatibility_motostem", modelSelect.options[modelSelect.selectedIndex].dataset['motostem']);
      localStorage.setItem("compatibility_motostemboost", modelSelect.options[modelSelect.selectedIndex].dataset['motostemboost']);
      localStorage.setItem("compatibility_mirror", modelSelect.options[modelSelect.selectedIndex].dataset['mirror']);
      localStorage.setItem("compatibility_mirrorpro", modelSelect.options[modelSelect.selectedIndex].dataset['mirrorpro']);
      localStorage.setItem("compatibility_scooterscrew", modelSelect.options[modelSelect.selectedIndex].dataset['scooterscrew']);
      localStorage.setItem("compatibility_proboosttu", modelSelect.options[modelSelect.selectedIndex].dataset['proboosttu']);
      localStorage.setItem("compatibility_protu", modelSelect.options[modelSelect.selectedIndex].dataset['protu']);
      localStorage.setItem("compatibility_mototu", modelSelect.options[modelSelect.selectedIndex].dataset['mototu']);
      localStorage.setItem("compatibility_motostemboostmini", modelSelect.options[modelSelect.selectedIndex].dataset['motostemboostmini']);



      var currentProductTypologyTrim = currentProductTypology.toLowerCase().replace(/\s/g, '');

      if(modelSelect.options[modelSelect.selectedIndex].dataset[currentProductTypologyTrim] == "OUI") {
        if(motoCompatibilityTrue){
          motoCompatibilityTrue.style.display = 'block';
        }
        if(motoCompatibilityFalse){
          motoCompatibilityFalse.style.display = 'none';
        }
        mmUpdateCTA(true, brandSelect.options[brandSelect.selectedIndex].innerText, modelSelect.options[modelSelect.selectedIndex].innerText);
      } else {
        if(motoCompatibilityTrue){motoCompatibilityTrue.style.display = 'none'}
        if(motoCompatibilityFalse){motoCompatibilityFalse.style.display = 'block'}
        mmUpdateCTA(false, brandSelect.options[brandSelect.selectedIndex].innerText, modelSelect.options[modelSelect.selectedIndex].innerText);
      }

      motoResult.innerHTML = "";

      // FIRST RECO
      // 1re carte : le produit désigné par la colonne "Recommandation" du JSON.
      // Si reco == "aucun" -> message d'excuse (sorryText) et flèches Splide masquées.
      var counter = 0;
      motoProductsData.forEach(function(motoProductData){
        // Skip products with missing data (deleted/unavailable)
        if (!motoProductData.dataset.title || !motoProductData.dataset.image || !motoProductData.dataset.url) return;
        var datasetArgu = 'argu' + modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase().replace(/\s/g, '');
        if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() == motoProductData.dataset.name.toLowerCase()) {
			counter += 1;
			var recoProductCard = `
          <li class="splide__slide mm-moto-reco-card">
            <img src="${motoProductData.dataset.image}">
            <div class="mm-moto-reco-card-content">
              <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
              <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
              <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
            </div>
            <p class="mm-moto-reco-card-argu">${motoProductData.dataset.compatibleTxt}</p>
          </li>
          `;
			motoResult.insertAdjacentHTML("beforeend", recoProductCard);
		} else if (modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() == "aucun") {
          motoResult.innerHTML = `
          <div class="mm-moto-result-aucun">
          ${sorryText}
          </div>
          <style>.splide-moto-result .splide__arrows {display:none}</style>
          `
        }
      })

      // 2ND and 3RD RECO
      // Cartes suivantes (plafond global : 4) : un bloc quasi identique par
      // typologie compatible ("OUI"), en excluant celle déjà affichée en reco
      // principale. Code très répétitif : seuls le nom de la typologie et le
      // texte argumentaire (data-argu*) changent d'un bloc à l'autre.
      motoProductsData.forEach(function(motoProductData){
        // Skip products with missing data (deleted/unavailable)
        if (!motoProductData.dataset.title || !motoProductData.dataset.image || !motoProductData.dataset.url) return;
        // MOTO
        if(modelSelect.options[modelSelect.selectedIndex].dataset.moto == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto") {
            if(motoProductData.dataset.name == "Moto") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumoto}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO PRO
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motopro == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto pro") {
            if(motoProductData.dataset.name == "Moto Pro") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotopro}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO PRO BOOST
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motoproboost == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto pro boost") {
            if(motoProductData.dataset.name == "Moto Pro Boost") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotoproboost}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO STEM
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motostem == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto stem") {
            if(motoProductData.dataset.name == "Moto Stem") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotostem}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO STEM BOOST
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motostemboost == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto stem boost") {
            if(motoProductData.dataset.name == "Moto Stem Boost") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotostemboost}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MIRROR
        if(modelSelect.options[modelSelect.selectedIndex].dataset.mirror == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "mirror") {
            if(motoProductData.dataset.name == "Mirror") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumirror}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MIRROR PRO
        if(modelSelect.options[modelSelect.selectedIndex].dataset.mirrorpro == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "mirror pro") {
            if(motoProductData.dataset.name == "Mirror Pro") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumirrorpro}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // SCOOTER SCREW
        if(modelSelect.options[modelSelect.selectedIndex].dataset.scooterscrew == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "scooter screw") {
            if(motoProductData.dataset.name == "Scooter Screw") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.arguscooterscrew}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // PRO BOOST TU
        if(modelSelect.options[modelSelect.selectedIndex].dataset.proboosttu == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "pro boost tu") {
            if(motoProductData.dataset.name == "Pro Boost TU") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.arguproboosttu}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // Pro Tu
        if(modelSelect.options[modelSelect.selectedIndex].dataset.protu == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "pro tu") {
            if(motoProductData.dataset.name == "Pro TU") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.arguprotu}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // Moto Tu
        if(modelSelect.options[modelSelect.selectedIndex].dataset.mototu == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto tu") {
            if(motoProductData.dataset.name == "Moto Tu") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumototu}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // Moto Stem Boost Mini
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motostemboostmini == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto stem boost mini") {
            if(motoProductData.dataset.name == "Moto Stem Boost Mini") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee} - ${motoProductData.dataset.price}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotostemboostmini}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
      });

    }
    splideRecos.refresh();
    toggleTitleSplide(counter);

  })
}

// Affiche le titre du carrousel de recos uniquement s'il y a au moins une carte.
function toggleTitleSplide(counter) {
  const splideTitle = document.querySelector(".mm-moto-results-title");
  if (counter > 0) {
    splideTitle.style.display = "flex";
  } else {
    splideTitle.style.display = "none";
  }
}

// END
// Envoie (en no-cors, fire-and-forget) la marque/le modèle saisis vers un
// Google Sheet via une WebApp Apps Script — sert à logger les motos non trouvées.
// Appelée depuis le formulaire "moto introuvable" du Liquid (URL codée en dur).
function sendQueryMoto(data1, data2) {
  const GOOGLE_WEBAPP_URL = 'https://script.google.com/macros/s/AKfycbzbvLbcOy41cF-8Z29UtqyAJOdBHShtOE7CgjokDuR5zh9yKBmRDEWOAK0Bq8FuoSJz/exec';

  const sendDataToGoogleSheet = (data1, data2 = '') => {
    fetch(GOOGLE_WEBAPP_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text1: data1, text2: data2 }),
    })
    .then(response => console.log('Success!', response))
    .catch(error => console.error('Error!', error));
  }

  sendDataToGoogleSheet(data1, data2);
}

// Croix du badge CTA : oublie le modèle mémorisé puis recharge la page pour
// restaurer le bouton d'origine. Exposée en global (onclick inline).
function forgetUserChoice() {
  // Set item
  localStorage.removeItem("Moto_model");

  location.reload();
}

// Au chargement de page : si un modèle est mémorisé ("Moto_model"), pré-remplit
// le champ de recherche, transforme directement le bouton CTA en badge
// compatible/non compatible (d'après les clés compatibility_* du localStorage),
// puis rejoue la sélection dans les selects cachés pour re-générer les recos.
function getMotoModel() {
  if(localStorage.getItem("Moto_model")){
    var moto_model = localStorage.getItem("Moto_model");

    // Pre-fill the search input with saved model
    motoSearchInput.value = moto_model;

    // 15.06.2026 : querySelectorAll (au lieu de querySelector) pour remplacer
    // TOUS les boutons moto au chargement — cohérent avec getPhoneModel et avec
    // la validation (mmUpdateCTAMoto). Avant, seul le 1er bouton était mis à
    // jour au rechargement (le sticky revenait en blanc) ; et la nouvelle barre
    // guide support mobile n'était pas reprise. Corrige les deux.
    var motoButtons = document.querySelectorAll('#product-form .mm-moto-modal-button');

    var currentProductTypologyTrim = currentProductTypology.toLowerCase().replace(/\s/g, '');
    var currentProductTypologyTrimFinal = 'compatibility_' + currentProductTypologyTrim;
    if(localStorage.getItem(currentProductTypologyTrimFinal) == 'OUI') {
      var is_compatible = true;
    } else {
      var is_compatible = false;
    }

    motoButtons.forEach(function(button) {
      const isDesktop = button.classList.contains('mm-desktop');

      const baseClass = 'mm-moto-modal-button';
      const desktopClass = isDesktop ? ' mm-desktop' : '';
      const compatibilityClass = is_compatible
        ? ' mm-moto-cta-compatible'
        : ' mm-moto-cta-not-compatible';

      button.outerHTML = `
        <span class="${baseClass}${compatibilityClass}${desktopClass}" id="mmMotoModalButton">
          <p onclick="mmOpenMotoModal()">${moto_model}</p>
          <svg onclick="forgetUserChoice()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </span>
      `;
    });

    // Now we populate the modal via hidden selects
    function mmSlug(str) {
      return str.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }
    var brandSlug = mmSlug(moto_model.split(' - ')[0]);
    var modelSlug = mmSlug(moto_model.split(' - ')[1] || '');

    for(var i=0; i < brandSelect.options.length; i++) {
        if(brandSelect.options[i].value == brandSlug) {

            brandSelect.selectedIndex = i;

            var event = new Event('change');
            brandSelect.dispatchEvent(event);

            for(var j=0; j < modelSelect.options.length; j++) {
                if(modelSelect.options[j].value == modelSlug) {
                    modelSelect.selectedIndex = j;

                    var event = new Event('change');
                    modelSelect.dispatchEvent(event);
                    validateModel.click()
                    break;
                }
              }
          break
        }
    }
  }
}

// Setup button onload
// 29/07/2026 : le rejeu attend que la base motos (téléchargée en asynchrone
// par chargerBaseMotos) soit chargée — sinon les selects sont encore vides
// au moment de rejouer la sélection mémorisée.
document.addEventListener("DOMContentLoaded", (event) => {
  if (mmBaseMotosPrete) {
    mmBaseMotosPrete.then(getMotoModel);
  } else {
    getMotoModel();
  }
});
